//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

//api
import { api } from '../../../../functions/api';

//custom components
import CustomInput from '../../../../components/basic/input';

//material-ui
import { Grid, Paper, MuiThemeProvider, createMuiTheme } from '@material-ui/core'

@inject('internal')
@inject('translate')
@observer
export default class Seo extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    timeout = null

    handleOnChange = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateData()
        }, 500)
    }

    updateData = async() => {

        let id = this.props.routerData.match.params.id
        let update_data = await api({
            method:'PATCH',
            url: `lists/shops/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                additional_page_title: this.additional_page_title.state.value,
                analytics_code: this.analytics_code.state.value,
                page_title: this.page_title.state.value,
                tag_manager_code: this.tag_manager_code.state.value,
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    render () {
        return (
            <div className={'shopDetailContainer'}>
                <div className="content">
                    <Grid container spacing={16} >
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper className={'paperContainer'}>
                                <CustomInput
                                    ref={ref => (this.page_title = ref)}
                                    text={this.props.translate.i18n.MODULES.SHOPS.PAGE_TITLE}
                                    value={toJS(this.props.internal.dataForTable.page_title)}
                                    id={"page_title"}
                                    className={"w-100"}
                                    change={this.handleOnChange}
                                />
                                <CustomInput
                                    ref={ref => (this.additional_page_title = ref)}
                                    text={this.props.translate.i18n.MODULES.SHOPS.ADDITIONAL_PAGE_TITLE}
                                    value={toJS(this.props.internal.dataForTable.additional_page_title)}
                                    id={"additional_page_title"}
                                    className={"w-100"}
                                    change={this.handleOnChange}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper className={'paperContainer'}>
                                <CustomInput
                                    ref={ref => (this.analytics_code = ref)}
                                    text={this.props.translate.i18n.MODULES.SHOPS.ANALYTICS_CODE}
                                    value={toJS(this.props.internal.dataForTable.analytics_code)}
                                    id={"analytics_code"}
                                    className={"w-100"}
                                    change={this.handleOnChange}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper className={'paperContainer'}>
                                <CustomInput
                                    ref={ref => (this.tag_manager_code = ref)}
                                    text={this.props.translate.i18n.MODULES.SHOPS.TAG_MANAGER_CODE}
                                    value={toJS(this.props.internal.dataForTable.tag_manager_code)}
                                    id={"tag_manager_code"}
                                    className={"w-100"}
                                    change={this.handleOnChange}
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/shops/detail/seo/Seo.jsx